import { useQuery } from '@apollo/client';

import { GET_ORGANIZATIONS } from '../gqlQueries/queries';

export const useGetOrganizationData = () => {
    const { data, loading } = useQuery(GET_ORGANIZATIONS, { fetchPolicy: 'cache-and-network' });

    return [data?.getOrganizations?.organizations, loading];
};
